import {
	ADD_FOUND_MAP,
	REMOVE_FOUND_MAP,
	ADD_DOWNLOADED_MAP,
	REMOVE_DOWNLOADED_MAP,
	SHOW_DOWNLOADED_MAP,
	HIDE_DOWNLOADED_MAP,
	SHOW_DOWNLOADED_MAPS,
	HIDE_DOWNLOADED_MAPS,
	SHOW_FOUND_MAPS,
	HIDE_FOUND_MAPS,
	ADD_FOUND_MAPS,
	SHOW_DOWNLOADED_MAP_INFO,
	HIDE_DOWNLOADED_MAP_INFO,
	TOGGLE_SHOW_DOWNLOADED_MAP_MARKERS,
	CLEAR_DOWNLOADED_MAPS
} from 'constants';
import * as ActionTypes from 'constants';

/** downloaded_map reducer has a wrapper object around an object from the {@link Map} collection for adding settings to map objects downloaded from the server. */
export const downloaded_map = (state = {
	id : undefined,
	map : null,
	visible : true,
	markers_visible: true,
	show_info : false,
	zIndex : 1
}, action) => {

	var {type, payload} = action;
	switch(type) {
		case ADD_DOWNLOADED_MAP:
			return {
				...state,
				id : payload.map._id,
				map : payload.map,
				visible : typeof payload.visible !== 'undefined' ? payload.visible : true,
				zIndex : payload.zIndex,
				markers_visible: true
			}
		case SHOW_DOWNLOADED_MAP:
			if(state.id == action.payload.id)
				return {
					...state,
					visible: true
				}
			else
				return state;
		case HIDE_DOWNLOADED_MAP:
			if(state.id == action.payload.id)
				return {
					...state,
					visible: false
				}
		default:
			return state;
	}
	return state;
}

/** map_search reducer has two arrays. One to store 'partial' maps searched for in the mapSearch component and one to store fully downloaded maps.
* @memberof Reducers.Maps
* @param {object} state
* @param {object} action
* @param {object} action.payload
*
* @returns {object} newState
*/

export const map_search = (state = {
	found_maps : [],
	downloaded_maps : [],
  downloading_maps : false,
  finding_maps : false,
	show_downloaded_maps : true,
	show_found_maps : true,
  fetching_map_ids : [],
	favoriting_map : false,
}, action) => {
	var {type, payload} = action;

	switch(type) {
    case ActionTypes.FETCH_MAP:
      return {
        ...state,
        fetching_map_ids : [...state.fetching_map_ids, payload.id]
      }
    case ActionTypes.FETCH_MAP_SUCCESS:case ActionTypes.FETCH_MAP_FAILURE:
      return {
        ...state,
        fetching_map_ids : [...state.fetching_map_ids.filter(id => id != payload.id)]
      }
		case ADD_FOUND_MAP:
			var {found_maps} = state;
			var existsIndex = -1;
			found_maps.find((map,index) => {
				var truthy = map._id == payload.map._id;
				if(truthy) existsIndex = index;
				return truthy;
			});

			if(existsIndex > -1)
				return {
					...state,
					found_maps: [
						...found_maps.slice(0, existsIndex),
						payload.map,
						...found_maps.slice(existsIndex+1,found_maps.length)
					]
				}
			else
				return {
					...state,
					found_maps: [
						...found_maps,
						payload.map
					]
				}
		case ADD_FOUND_MAPS:
			return {
				...state,
				found_maps : action.payload.maps
			}
		case REMOVE_FOUND_MAP:
			var {found_maps} = state;
			var removeIndex = -1;
			if(payload.id)
				found_maps.find((map, index) => {
					if(!map)
						return false;

					var truthy = map._id == payload.id;
					if(truthy) removeIndex = index;
					return truthy;
				});
			if(removeIndex > -1)
				return {
					...state,
					found_maps : [...found_maps.slice(0, removeIndex), ...found_maps.slice(removeIndex + 1, found_maps.length)],
				}
			else
				return {
					...state
				}
		case ADD_DOWNLOADED_MAP:
			var {downloaded_maps} = state;
			var existsIndex = -1;
			downloaded_maps.find((map, index) => {
				if(!payload.map || !map)
					return false;

				var truthy = map.id == payload.map._id;
				if(truthy) existsIndex = index;
				return truthy;
			})
			if(existsIndex > -1)
				return {
					...state,
					downloaded_maps : [
						...downloaded_maps.slice(0, existsIndex),
						downloaded_map(null, action),
						...downloaded_maps.slice(existsIndex+1, downloaded_maps.length)
					]
				}
			else
				return {...state, downloaded_maps : [...downloaded_maps, downloaded_map(null,action)]}
		case REMOVE_DOWNLOADED_MAP:
			var {downloaded_maps} = state;
			var removeIndex = -1;
			downloaded_maps.find((map, index) => {
				var truthy = map.id == payload.id;
				if(truthy) removeIndex = index;
				return truthy;
			});
			if(removeIndex > -1)
				return {
					...state,
					downloaded_maps : [...downloaded_maps.slice(0,removeIndex),...downloaded_maps.slice(removeIndex + 1, downloaded_maps.length)]
				}
		case SHOW_DOWNLOADED_MAP: case HIDE_DOWNLOADED_MAP: case SHOW_DOWNLOADED_MAP_INFO: case HIDE_DOWNLOADED_MAP_INFO:
			var {downloaded_maps} = state;
			return {
				...state,
				downloaded_maps : downloaded_maps.map(map => downloaded_map(map, action))
			}
		case SHOW_DOWNLOADED_MAPS:
			return {
				...state,
				show_downloaded_maps : true
			}
		case HIDE_DOWNLOADED_MAPS:
			return {
				...state,
				show_downloaded_maps : false
			}
		case SHOW_FOUND_MAPS:
			return {
				...state,
				show_found_maps : true
			}
		case HIDE_FOUND_MAPS:
			return {
				...state,
				show_found_maps : false
			}
		case TOGGLE_SHOW_DOWNLOADED_MAP_MARKERS: {
			const { map_id, markers_visible } = payload;
			return {
				...state,
				downloaded_maps: state.downloaded_maps.map(m => m.id == map_id ? { ...m, markers_visible: markers_visible != null ? markers_visible : !m.markers_visible } : m)
			};
		}
		case CLEAR_DOWNLOADED_MAPS: {
			return {
				...state,
				downloaded_maps: [],
				found_maps: []
			};
		}
		default:
			return state;
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/common/reducers/map_search.js